<template>
    <div v-observe-visibility="visibilityChanged">


        <v-dialog class="loading-dialog"
                  v-model="creatingSupplierOrders"
                  persistent
                  overlay
                  max-width="450px">
            <v-card>
                <v-layout row pt-4 pb-4 pr-4 pl-4>
                    <v-flex xs12>
                        <v-card-title class="headline">Creating Supplier Orders...</v-card-title>
                    </v-flex>
                    <v-flex justify-end>
                        <v-progress-circular
                                :size="70"
                                :width="7"
                                color="primary"
                                indeterminate
                        ></v-progress-circular>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-dialog>

        <!--DELETE - Dialog-->
        <!--
                <v-dialog
                        persistent
                        v-model="deleteDialog" max-width="400px">
                    <v-card>
                        <v-card-title>
                            <span class="headline">Delete Position</span>
                        </v-card-title>

                        <v-card-text>
                            <v-form ref="form" v-model="deleteFormValidation" lazy-validation>
                                <v-checkbox
                                        :rules="[v => !!v || 'You have to check this to continue!']"
                                        required
                                        v-model="deleteChecked" color="primary"
                                        label="Do you really want to delete this position?"></v-checkbox>
                            </v-form>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary darken-1" flat @click.native="cancelDeleteDialog()">CANCEL</v-btn>
                            <v-btn color="primary darken-1" flat @click.native="deletePosition()">
                                OK
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
        -->


        <v-layout id="table-container" row>
            <v-flex xs12 pr-4 pt-4 pl-4>
                <v-card>
                    <v-card-title>
                        Procurement Positions
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="search"
                                label="Search"
                                single-line
                                hide-details
                                clearable
                        ></v-text-field>
                    </v-card-title>

                    <v-data-table
                            :headers="headers"
                            :items="getItems"
                            :pagination.sync="pagination"
                            :total-items=total
                            class="elevation-0 offer-table"
                            :loading="loading"
                            :rows-per-page-items="rowsPageItems"
                    >

                        <template slot="headerCell" slot-scope="props">
                            <v-tooltip bottom>
                                        <span slot="activator">
                                          {{ props.header.text }}
                                        </span>
                                <span>
                                          {{ props.header.text }}
                                        </span>
                            </v-tooltip>
                        </template>
                        <template slot="items" slot-scope="props">
                            <tr @dblclick="openProcurementPositionDialog(props.item.id)">
                                <td>{{ props.item.id }}</td>
                                <td class="text-xs-left">{{
                                    props.item.purchase_orders_position.purchase_order.purchase_orders_number }}
                                </td>
                                <td class="text-xs-left">{{
                                    props.item.suppliers_offers_position.suppliers_offer.supplier.name }}
                                </td>
                                <td class="text-xs-left">{{ props.item.purchase_orders_position.product.reference }}
                                </td>
                                <td class="text-xs-left">{{
                                    props.item.purchase_orders_position.product.manufacturer.name }}
                                </td>
                                <td class="text-xs-left">{{ props.item.purchase_orders_position.quantity }}</td>
                                <td class="text-xs-left">{{props.item.purchase_orders_position.unit.code }}</td>
                                <td class="text-xs-right">{{props.item.purchase_orders_position.unit_sales_price | toMoney}}
                                    {{props.item.purchase_orders_position.purchase_order.currency.name}}
                                </td>
                                <td class="text-xs-right">{{props.item.purchase_orders_position.total_sales_price | toMoney}}
                                    {{props.item.purchase_orders_position.purchase_order.currency.name}}
                                </td>
                                <td class="text-xs-left">{{ props.item.procurements_positions_status.name }}</td>

                                <!--                        <td class="text-xs-right">

                                                            <v-icon color="red"
                                                                    class="ma-1"
                                                                    @click="deletePositionDialog(props.item)"
                                                            >
                                                                delete
                                                            </v-icon>
                                                        </td>-->
                            </tr>
                        </template>
                    </v-data-table>

                </v-card>
            </v-flex>
        </v-layout>

        <v-layout row wrap justify-end mr-5>
            <v-flex xs12 sm12 md1 pr-4 pt-4 mr-5>
                <v-btn :loading="getCreatingSupplierOrders" color="secondary"
                       @click.native="createSupplierOrders()">
                    Create Supplier Orders
                </v-btn>
            </v-flex>
        </v-layout>
        <!--Confirm Dialog-->
        <confirmProcurementPosition></confirmProcurementPosition>

    </div>
</template>

<script>
    import {
        Settings,
        Procurement,
        ProcurementPosition
    } from '../../../store/namespace-helper'
    import {numberFormatFilters} from '../../../mixins/numberFormatFilters'
    import confirmProcurementPosition from './ConfirmProcurementPositionDialog.vue'

    import _ from 'lodash'

    export default {
      mixins: [numberFormatFilters],
      name: 'procurement-positions',
      components: {confirmProcurementPosition},
      data () {
        return {
          isVisible: false,
          hide: true,
          activeTab: 0,
          headers: [
                    {text: 'Position-ID', value: 'id'},
                    {text: 'Customer Order Confirmation', value: 'purchase_orders_number'},
                    {text: 'Selected Supplier', value: 'supplier.name', sortable: false},
                    {text: 'Reference', value: 'reference'},
                    {text: 'Manufacturer', value: 'manufacturers_id'},
                    {text: 'Quantity', value: 'quantity'},
                    {text: 'Unit', value: 'unit_id', sortable: false},
                    {text: 'Unit Sales Price', value: 'unit_sales_price', align: 'right'},
                    {text: 'Total Sales Price', value: 'total_sales_price', align: 'right'},
                    {text: 'Status', value: 'inquiries_position_status_id'}
                    /*                    {text: 'Action', value: 'action', sortable: false} */
          ],
          pagination: {},
          search: '',
          total: 0,
          rowsPageItems: [{'text': 'All', 'value': -1}],
          creatingSupplierOrders: false,
          positionData: null,
          deleteDialog: false,
          deleteChecked: false,
          deleteFormValidation: false
        }
      },
      mounted () {

      },
      methods: {
        visibilityChanged (isVisible, entry) {
          if (this.isVisible !== isVisible) {
            this.isVisible = isVisible
            if (isVisible) {
              console.log('tab order positions visible, load data')
              this.loadItems()
            } else {

            }
          }
        },
        loadItems: function () {
          const {sortBy, descending, page, rowsPerPage} = this.pagination
          const query = {
            id: this.selectedItem.id,
            sortBy: sortBy || 'id',
            descending: descending ? 'desc' : 'asc',
            page: page || 1,
            limit: rowsPerPage !== -1 ? rowsPerPage : 0,
            search: this.search ? this.search : ''
          }
          if (this.selectedItem.id !== 0) {
            this.$store.dispatch(ProcurementPosition.actions.loadProcurementPositions, query)
          }
        },
        createSupplierOrders () {
          this.$store.dispatch(Procurement.actions.createSupplierOrders, this.selectedItem.id).then(response => {
            this.creatingSupplierOrders = true
            this.$echo.private('supplier-order-created-chan.' + this.selectedItem.id).listen('SupplierOrdersCreated', (payload) => {
              console.log('message sent event: ' + JSON.stringify(payload))
  /*            this.$store.dispatch(Procurement.actions.reloadSelectedPurchaseOrder, this.selectedItem.id).then(response => {

              }) */

              this.$echo.leave('supplier-order-created-chan.' + this.selectedItem.id)
              this.creatingSupplierOrders = false
            })
          })
        },
        openProcurementPositionDialog (val) {
          let item = this.getItems.find(x => x.id === val)
          if (item !== null && typeof item !== 'undefined') {
            console.log('selectedOrderPosition: ' + JSON.stringify(item))
            this.$store.dispatch(ProcurementPosition.actions.setSelectedProcurementPosition, item)
          }
          this.$store.dispatch(ProcurementPosition.actions.openCloseDialog)
        },
        throttledLoadItems: _.debounce(function () {
          this.loadItems()
        }, 450),
        throttledTranslate: _.debounce(function (q, target) {
          this.translate(q, target)
        }, 450),
        deletePositionDialog (item) {
          this.positionData = _.cloneDeep(item)
          this.deleteDialog = true
        }
            /*        deletePosition () {
                      if (!this.$refs.form.validate()) {
                        return
                      }
                      this.deleteDialog = false
                      this.deleteChecked = false
                      this.$store.dispatch(ProcurementPosition.actions.deleteOrderPositions, this.positionData).then(response => {
                        if (response !== null) {
                          this.loadItems()
                        }
                      })
                    }, */
            /*        cancelDeleteDialog () {
                      this.deleteDialog = false
                      this.$refs.form.reset()
                    } */

      },
      computed: {
        getItems () {
          this.total = this.$store.getters[ProcurementPosition.getters.procurementPositions].length
          return this.$store.getters[ProcurementPosition.getters.procurementPositions]
        },
        selectedItem () {
          return this.$store.getters[Procurement.getters.getSelectedProcurement]
        },
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        getCreatingSupplierOrders () {
          return this.$store.getters[Procurement.getters.creatingSupplierOrders]
        },
        confirmOrderPositionDialogState () {
          return this.$store.getters[ProcurementPosition.getters.getOpenDialogState]
        }
      },
      watch: {
        pagination: {
          handler () {
            this.loadItems()
          },
          deep: true
        },
        confirmOrderPositionDialogState: {
          handler (val) {
            if (!val) {
              this.loadItems()
            }
          },
          deep: true
        },
        search: {
          handler (val) {
            this.throttledLoadItems()
          },
          deep: true
        }
      }

    }
</script>

<style scoped>

    th:focus {
        outline: none !important;
    }


</style>


// WEBPACK FOOTER //
// src/components/Procurements/ProcurementPositions/ProcurementPositions.vue